import { types } from 'mobx-state-tree';
import axios from 'axios';

const CANCELED_OPERATION_MESSAGE = 'Operation canceled by the user.';

const Model = {
  pendingCallsCount: 0
};

const Actions = (self: any) => {
  const CancelToken = axios.CancelToken;
  let source = CancelToken.source();
  return {
    incrementPendingCalls: () => self.pendingCallsCount++,
    decrementPendingCalls: () => self.pendingCallsCount--,
    getCancelToken: () => source.token,
    abort: function() {
      source.cancel(CANCELED_OPERATION_MESSAGE);
      source = CancelToken.source();
    }
  };
};

const Views = (self: any) => ({
  get isFetching() {
    return Boolean(self.pendingCallsCount);
  }
});

export const SimpleApiStore = types
  .model('SimpleApiStore', Model)
  .actions(Actions)
  .views(Views);
